import * as actionTypes from './actionTypes';
import { accessService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

const fetchAccessRequest = () => ({
  type: actionTypes.FETCH_ACCESS_REQUEST
});

const fetchAccessFailure = () => ({
  type: actionTypes.FETCH_ACCESS_FAILURE
});

const fetchAccessSuccess = (data) => ({
  type: actionTypes.FETCH_ACCESS_SUCCESS,
  data
});

export const clearAccessData = () => ({
  type: actionTypes.CLEAR_ACCESS_DATA
});

export const fetchAccess = () => {
  return async dispatch => {
    dispatch(fetchAccessRequest());
    try {
      const json = {'user': 'admin', 'role': 'user'};
      const data = await accessService.post(json);
      if (data.error && data.data && data.data.length === 0) {
        dispatch(actionsModalError.openModalError(data.message));
        dispatch(fetchAccessFailure());
      } else {
        const currentData = data.data[0];
        dispatch(fetchAccessSuccess(currentData));
        const app = JSON.parse(localStorage.getItem('app'));
        const updateApp = {
          ...app,
          jwt: currentData && currentData.jwt
        }
        if (isClient) {
          localStorage.setItem('app', JSON.stringify(updateApp));
        }
      }
    } catch (error) {
      console.log(`Error fetch access action ${error}`);
      dispatch(actionsModalError.openModalError('Ocurrió un error'));
      dispatch(fetchAccessFailure());
    }
  }
}
